const TAG_STYLE_PALETTE = [
    'bg-blue-50 text-blue-700 border-blue-200',
    'bg-emerald-50 text-emerald-700 border-emerald-200',
    'bg-amber-50 text-amber-700 border-amber-200',
    'bg-rose-50 text-rose-700 border-rose-200',
    'bg-indigo-50 text-indigo-700 border-indigo-200',
    'bg-cyan-50 text-cyan-700 border-cyan-200',
    'bg-lime-50 text-lime-700 border-lime-200',
    'bg-violet-50 text-violet-700 border-violet-200',
];

const normalizeTag = (value: string) => value.trim().toLowerCase();

const hashTag = (value: string) => {
    const normalized = normalizeTag(value);
    let hash = 0;
    for (let index = 0; index < normalized.length; index += 1) {
        hash = (hash * 31 + normalized.charCodeAt(index)) >>> 0;
    }
    return hash;
};

export const getTagPillClasses = (tag: string) => {
    const hash = hashTag(tag);
    return TAG_STYLE_PALETTE[hash % TAG_STYLE_PALETTE.length];
};

export const getTypePillClasses = (type?: string) => {
    const normalized = (type || '').toLowerCase();
    if (normalized === 'invoice') return 'bg-blue-50 text-blue-700 border-blue-200';
    if (normalized === 'expenses') return 'bg-cyan-50 text-cyan-700 border-cyan-200';
    if (normalized === 'bills') return 'bg-amber-50 text-amber-700 border-amber-200';
    if (normalized === 'statement') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    if (normalized === 'pl_report') return 'bg-teal-50 text-teal-800 border-teal-200';
    return 'bg-gray-50 text-gray-700 border-gray-200';
};

/** Display label for document type badges (matches Documents UI design). */
export const formatDocumentTypeLabel = (type?: string | null): string => {
    const t = (type || '').toLowerCase();
    if (t === 'pl_report') return 'P&L';
    if (t === 'bank_statement') return 'Statement';
    if (t === 'vendor_invoice') return 'Invoice';
    if (t === 'vendor_bill') return 'Bill';
    return type || 'unknown';
};

export const formatFileSize = (size?: number | null) => {
    if (!size || Number.isNaN(size) || size <= 0) return '—';
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    let value = size;
    let unitIndex = 0;
    while (value >= 1024 && unitIndex < units.length - 1) {
        value /= 1024;
        unitIndex += 1;
    }
    const rounded = unitIndex === 0 ? Math.round(value) : value < 10 ? value.toFixed(1) : Math.round(value);
    return `${rounded} ${units[unitIndex]}`;
};

export const normalizeTagLabel = (value: string) => value.trim().replace(/\s+/g, ' ');

export const isSameTagLabel = (left: string, right: string) =>
    normalizeTagLabel(left).toLowerCase() === normalizeTagLabel(right).toLowerCase();
